import apiClient from "./api-client";
import StorageHelper from "../utils/storage-helper";

const getHeaders = () => ({
  headers: {
    Authorization: 'Bearer ' + StorageHelper.get('token'),
    'Content-Type': 'application/json'
  }
});

const getMultipartHeaders = () => ({
  headers: {
    Authorization: 'Bearer ' + StorageHelper.get('token'),
    'Content-Type': 'multipart/form-data'
  }
});

const BASE_URL = 'claims';

export const getMyClaims = async () => {
  return apiClient.get(BASE_URL, getHeaders());
};

export const getAllClaims = async () => {
  return apiClient.get(`${BASE_URL}/all`, getHeaders());
};

export const getClaimDocumentTypes = async () => {
  return apiClient.get(`${BASE_URL}/document-types`, getHeaders());
};

export const createClaim = async (claimSubmissionRequest) => {
  return apiClient.post(`${BASE_URL}/submit`, claimSubmissionRequest, getHeaders());
};

export const uploadClaimDocument = async (referenceNumber, documentType, file) => {
  const formData = new FormData();
  formData.append('documentType', documentType);
  formData.append('file', file);
  return apiClient.post(`${BASE_URL}/${referenceNumber}/documents`, formData, getMultipartHeaders());
};

export const trackClaims = async () => {
  return apiClient.get(`${BASE_URL}/track`, getHeaders());
};

export const approveOrRejectClaim = async (referenceNumber, approve, comment) => {
  return apiClient.post(`${BASE_URL}/${referenceNumber}/review`, { approve, comment }, getHeaders());
};
